import request from '@/router/axios';

export function getCloudCostDetailMobileList(data) {
  return request({
    url: "/costInvoiceFolder/getCloudCostDetailMobileList",
    method: 'POST',
    data: data
  });
}

export function getInvoiceFolderOrcByAttachids(data) {
  return request({
    url: "/costInvoiceFolder/getInvoiceFolderOrcByAttachids",
    method: 'POST',
    data: data
  });
}

export function getCloudCostStatusList(data) {
  return request({
    url: "/costApplicationController/getCloudCostStatusList",
    method: 'POST',
    data: data
  });
}

export function getCloudOrgPersonTree(data) {
  return request({
    url: "/costApplicationController/getCloudOrgPersonTree",
    method: 'POST',
    data: data
  });
}

export function getCloudCostEditInitData(data) {
  return request({
    url: "/costApplicationController/getCloudCostEditInitData",
    method: 'POST',
    data: data
  });
}

export function getCloudDeptByPerId(data) {
  return request({
    url: "/costApplicationController/getCloudDeptByPerId",
    method: 'POST',
    data: data
  });
}

export function getCloudTravelApplicationList(data) {
  return request({
    url: "/costApplicationController/getCloudTravelApplicationList",
    method: 'POST',
    data: data
  });
}

export function getCloudPersonPayee(data) {
  return request({
    url: "/costApplicationController/getCloudPersonPayee",
    method: 'POST',
    data: data
  });
}

export function getCloudPayeeAccount(data) {
  return request({
    url: "/costApplicationController/getCloudPayeeAccount",
    method: 'POST',
    data: data
  });
}

export function getCloudBorrowListByPerId(data) {
  return request({
    url: "/costApplicationController/getCloudBorrowListByPerId",
    method: 'POST',
    data: data
  });
}

export function getCloudJsonAssistProjectList(data) {
  return request({
    url: "/costApplicationController/getCloudJsonAssistProjectList",
    method: 'POST',
    data: data
  });
}

export function getCloudCusSupplierForContract(data) {
  return request({
    url: "/costApplicationController/getCloudCusSupplierForContract",
    method: 'POST',
    data: data
  });
}

export function getCloudConstractInfoBySupplierIdAndPersonId(data) {
  return request({
    url: "/costApplicationController/getCloudConstractInfoBySupplierIdAndPersonId",
    method: 'POST',
    data: data
  });
}

export function getCloudConstractInfoBySupplierId(data) {
  return request({
    url: "/costApplicationController/getCloudConstractInfoBySupplierId",
    method: 'POST',
    data: data
  });
}

export function getCloudConstractPaymentInfo(data) {
  return request({
    url: "/costApplicationController/getCloudConstractPaymentInfo",
    method: 'POST',
    data: data
  });
}

export function getCloudCusSupplierBySupplierId(data) {
  return request({
    url: "/costApplicationController/getCloudCusSupplierBySupplierId",
    method: 'POST',
    data: data
  });
}

export function getCloudCusSupplierPayeeId(data) {
  return request({
    url: "/costApplicationController/getCloudCusSupplierPayeeId",
    method: 'POST',
    data: data
  });
}

export function getCloudCusSupplier(data) {
  return request({
    url: "/costApplicationController/getCloudCusSupplier",
    method: 'POST',
    data: data
  });
}

export function saveCostCloud(data) {
  return request({
    url: "/costApplicationController/saveCostCloud",
    method: 'POST',
    data: data
  });
}

export function getCloudEditCostInfo(data) {
  return request({
    url: "/costApplicationController/getCloudEditCostInfo",
    method: 'POST',
    data: data
  });
}

export function getCloudCostDetailMobileById(data) {
  return request({
    url: "/costInvoiceFolder/getCloudCostDetailMobileById",
    method: 'POST',
    data: data
  });
}

export function saveCloudInvoiceFolder(data) {
  return request({
    url: "/costInvoiceFolder/saveCloudInvoiceFolder",
    method: 'POST',
    data: data
  });
}

export function deleteCloudInvoiceFolder(data) {
  return request({
    url: "/costInvoiceFolder/deleteCloudInvoiceFolder",
    method: 'POST',
    data: data
  });
}

export function updateCloudInvoiceFolderApprove(data) {
  return request({
    url: "/costInvoiceFolder/updateCloudInvoiceFolderApprove",
    method: 'POST',
    data: data
  });
}

export function makeCloudInvoiceFolderVerify(data) {
  return request({
    url: "/costInvoiceFolder/makeCloudInvoiceFolderVerify",
    method: 'POST',
    data: data
  });
}

export function deleteCloudCostInfo(data) {
  return request({
    url: "/costApplicationController/deleteCloudCostInfo",
    method: 'POST',
    data: data
  });
}

export function getCloudAvailableShareType(data) {
  return request({
    url: "/costApplicationController/getCloudAvailableShareType",
    method: 'POST',
    data: data
  });
}

export function getCloudShareProjectList(data) {
  return request({
    url: "/costApplicationController/getCloudShareProjectList",
    method: 'POST',
    data: data
  });
}

export function getCloudShareDeptList(data) {
  return request({
    url: "/costApplicationController/getCloudShareDeptList",
    method: 'POST',
    data: data
  });
}

export function saveCloudShareInfo(data) {
  return request({
    url: "/costApplicationController/saveCloudShareInfo",
    method: 'POST',
    data: data
  });
}

export function getCloudShareInfoByShareId(data) {
  return request({
    url: "/costApplicationController/getCloudShareInfoByShareId",
    method: 'POST',
    data: data
  });
}

export function delCloudShareInfo(data) {
  return request({
    url: "/costApplicationController/delCloudShareInfo",
    method: 'POST',
    data: data
  });
}

export function manageCloudApproveCostList(data) {
  return request({
    url: "/costApplicationController/manageCloudApproveCostList",
    method: 'POST',
    data: data
  });
}

export function myCloudApproveCostList(data) {
  return request({
    url: "/costApplicationController/myCloudApproveCostList",
    method: 'POST',
    data: data
  });
}

export function queryCloudCostProjectByProjectType(data) {
  return request({
    url: "/costApplicationController/queryCloudCostProjectByProjectType",
    method: 'POST',
    data: data
  });
}

export function queryCloudCostProjectByProjectType1(data) {
  return request({
    url: "/costApplicationController/queryCloudCostProjectByProjectType1",
    method: 'POST',
    data: data
  });
}

export function getViewCloudCostInfo(data) {
  return request({
    url: "/costApplicationController/getViewCloudCostInfo",
    method: 'POST',
    data: data
  });
}

export function approveWithdrawCloud(data) {
  return request({
    url: "/costApplicationController/approveWithdrawCloud",
    method: 'POST',
    data: data
  });
}

export function manageApproveCloud(data) {
  return request({
    url: "/costApplicationController/manageApproveCloud",
    method: 'POST',
    data: data
  });
}

